import React from 'react';
import { Component } from 'ml-component-web';

import loading from './loading.gif';

export default class LoadingIndicator extends Component {
    render() {
        const { size } = this.props;
        return (
            <div className="loading">
                <img src={loading} height={size} width={size} alt="Loading" />
            </div>
        );
    }
}
LoadingIndicator.defaultProps = {
    size: 40,
};



/** WEBPACK FOOTER **
 ** ./src/component/LoadingIndicator.js
 **/